var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.dialogs),function(dialog){return [_c(dialog.component,_vm._b({key:dialog.id,tag:"component",on:{"close":function($event){return _vm.onClose(dialog, $event)}}},'component',dialog.payload,false))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }